var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivityReportMaintenance = function SvgActivityReportMaintenance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7D2853",
    fillRule: "nonzero",
    d: "M14.783 2.802a.683.683 0 0 1 1.105.202c.27.594.412 1.23.412 1.881a4.586 4.586 0 0 1-5.856 4.407l-5.01 6.733a.683.683 0 0 1-1.032.075L.5 12.198a.683.683 0 0 1 .075-1.031l6.733-5.01A4.586 4.586 0 0 1 11.715.3c.652-.001 1.287.142 1.881.411a.683.683 0 0 1 .202 1.105l-1.605 1.605.985.985 1.605-1.605ZM13.66 5.856a.683.683 0 0 1-.966 0l-1.951-1.951a.683.683 0 0 1 0-.966l1.26-1.26a3.22 3.22 0 0 0-3.256 4.46c.122.29.03.626-.222.813l-6.501 4.839 2.784 2.784 4.839-6.501a.683.683 0 0 1 .813-.222 3.22 3.22 0 0 0 4.46-3.256l-1.26 1.26Z"
  })));
};
export default SvgActivityReportMaintenance;